
import { computed, defineComponent, inject, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
// import Timer from "./Timer.vue";
// import AppIcon from "@/components/AppIcon.vue";

import { mdiCheck } from "@mdi/js";
import { WsClient } from "@/ws/WsClient";

export default defineComponent({
  setup() {
    const store = useStore();

    const timePerTurn = computed(() => store.getters.getTimePerRound);
    const currentTime = computed(() => store.getters.getCurrentTime);

    const progress = computed(() => {
      return (currentTime.value * 100) / timePerTurn.value + "%";
    });

    const hintInput = ref<HTMLInputElement | null>(null);
    // throttling tracker
    const canSendHint = ref<boolean>(true);
    const hint = ref<string>("");
    const hintLenCount = computed(() => {
      return hint.value.length <= 100 ? hint.value.length : 100;
    });

    let throttle: number | null = null;

    const ws = inject("ws") as WsClient;
    const sendHint = () => {
      // if the input is empty or greater than 100 chars, dont run anything
      if (
        hint.value.length <= 0 ||
        hint.value.length > 100 ||
        !canSendHint.value
      ) {
        return;
      }
      // unfocus the input
      if (hintInput.value) hintInput.value.blur();

      // prevent further hint sending for throttle
      canSendHint.value = false;
      // dispatch the event to the server
      ws.dispatch.sendHint(hint.value);

      // throttle the input for 1.5sec
      throttle = setTimeout(() => {
        canSendHint.value = true;
        if (hintInput.value) hintInput.value.focus();
        if (throttle) clearTimeout(throttle);
      }, 1000);
      // reset the input
      hint.value = "";
    };

    onUnmounted(() => {
      if (throttle) clearTimeout(throttle);
    });

    return {
      word: computed(() => store.getters.getWord),
      playerFoundAnswer: computed(() => store.getters.getPlayerFoundAnswer),
      mdiCheck,
      currentRound: computed(() => store.getters.getCurrentRound),
      roundCount: computed(() => store.getters.getRoundCount),
      remainingTime: computed(() => store.getters.getCurrentTime),
      hasFoundAnswer: computed(() => store.getters.getPlayerFoundAnswer),
      isTurn: computed(() => store.getters.getIsTurn),
      // isTurn: true, // debug
      currentPlayer: computed(() => store.getters.getCurrentTurnPlayerName),
      guessHint: computed(() => store.getters.getGuessHint),
      currentTime,
      progress,
      hint,
      hintLenCount,
      sendHint,
      canSendHint,
      hintInput,
    };
  },
});
